import { useContext } from 'react'

import { ToastContext } from '@/shared/components/toastContext'

export function useToast() {
  const context = useContext(ToastContext)
  if (context === null) {
    throw new Error('useToast must be used inside ToastProvider')
  }

  return context
}
